// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logoLeft":"Header_logoLeft__YuqJP","logoCenter":"Header_logoCenter__9onS4","version":"Header_version__glFIF"};